import React, { Component } from 'react';
import './Filters.scss';
import * as _ from 'lodash';
import { TypeFilter } from './type-filter/TypeFIlter';
import { SeverityFilter } from './severity-filter/SeverityFIlter';
import { StatusToggleSelect } from '../status-toggle-select/StatusToggleSelect';
import { BlueContainedButton } from '../button/blue-contained-button/BlueContainedButton';
import TransparentButton from '../button/transparent-button/TransparentButton';

export class Filters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                type: null,
                severity: null,
                status: null
            }
        };
    }
    makeRows = () => {
        const { typeConfig, severityConfig, statusConfig } = this.props;
        return [
            typeConfig && (
                <TypeFilter
                    typeConfig={typeConfig}
                    updateFilter={this.onUpdateTypeFilter}
                    value={this.state.filters.type}
                />
            ),
            severityConfig && (
                <SeverityFilter
                    label={severityConfig.label}
                    updateFilter={this.onUpdateSeverityFilter}
                    value={this.state.filters.severity}
                />
            ),
            statusConfig && (
                <StatusToggleSelect
                    updateFilter={this.onUpdateStatusFilter}
                    value={this.state.filters.status}
                />
            )
        ];
    };

    onUpdateTypeFilter = type => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                type
            }
        });
    };

    onUpdateSeverityFilter = severity => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                severity
            }
        });
    };

    onUpdateStatusFilter = status => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                status
            }
        });
    };

    onApplyFilters = () => {
        if (_.has(this.state, 'type')) {
            this.props.typeConfig.selectSeverityLevel(this.state.type);
        }
        if (_.has(this.state, 'severity')) {
            this.props.severityConfig.selectSeverityLevel(this.state.severity);
        }
        if (_.has(this.state, 'status')) {
            this.props.statusConfig.selectSeverityLevel(this.state.status);
        }

        _.isFunction(this.props.applyFilters) &&
            this.props.applyFilters(this.state.filters);
    };

    onClearFilters = () => {
        this.setState(
            {
                ...this.state,
                filters: {
                    type: null,
                    severity: null,
                    status: null
                }
            },
            _.isFunction(this.props.clearFilters) &&
                this.props.clearFilters(this.state.filters)
        );
    };

    render = () => {
        return (
            <div className={'filters'}>
                {this.makeRows().map((row, key) => (
                    <div key={key} className={'row'}>
                        {row}
                    </div>
                ))}
                <div className={'row modal-actions'}>
                    <TransparentButton onClick={this.onClearFilters}>
                        Clear Filters
                    </TransparentButton>
                    <BlueContainedButton
                        onClick={this.onApplyFilters}
                        text={'Apply Filters'}
                    />
                </div>
            </div>
        );
    };
}
